import { render, staticRenderFns } from "./YoutubeRTMPForm.vue?vue&type=template&id=b47e8fb8&scoped=true&"
import script from "./YoutubeRTMPForm.vue?vue&type=script&lang=js&"
export * from "./YoutubeRTMPForm.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeRTMPForm.vue?vue&type=style&index=0&id=b47e8fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47e8fb8",
  null
  
)

export default component.exports